import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectLikeEntities } from '../EntitiesSelector';
import { selectCurrentUser } from '../AuthSelector';

export const selectCurrentUserLikes = createSelector([selectLikeEntities, selectCurrentUser], (likes, currentUser) => {
  const currentUserLikes = likes.filter(like => like?.get('ownerId') === currentUser?.get('id'));
  // Roughly equivalent to keyBy(currentUserLikes, 'id')
  return Immutable.Map(currentUserLikes.toList().map(v => [v.get('contentId'), v]));
});

const getLikeIds = state => state.getIn(['ugc', 'likes', 'results'], Immutable.List());
const pagination = state => state.getIn(['ugc', 'likes', 'pagination'], Immutable.Map());

export const selectAllContentLikes = createSelector([getLikeIds, selectLikeEntities], (likeIds, likeEntities) =>
  likeIds.map(likeId => likeEntities.get(likeId.toString()))
);

export const selectLikesPagination = createSelector([pagination], page => page);

export default {
  selectCurrentUserLikes,
  selectAllContentLikes,
  selectLikesPagination
};
